export const refNamesObjetosVisuaisNavBase = [
	"refMenuAssinaturas365",
	"refMenuUsuarios",
	"refMenuUsuariosExcluidos",
	"refMenuAtendimentos",
	"refMenuSolicitacaoServicos",
	"refMenuFinanceiro",
	"refMenuGrupos",
	"refMenuPrecisoSuporte",
	"refRelatorioAzure",
	"refRelatorioMaster",
	"refRelatorioFaturamentoMaster",
	"refRelatorioLicenciamentoCsp",
	"refRelatorioExtratoUsuario",
	"refRelatorioAtendimentos",
	"refRelatorioSuportePremium",
	"refRelatorioPainelSeguranca",
	"refRelatorioPainelFinOps",
	"refMenuAtualizarMeusDadosLateral",
	"refMenuAlterarSenhaLateral",
	"refSairLateral",
];

export const refNamesObjetosVisuaisUsuariosExcluidos = [
    'refBotaoRestaurar', 
    'refFiltroUsuarios', 
    'refPaginacaoUsuarios'
];